export enum CssClassModifiers {
    IsLive = "xg--is-live",
    IsPerforming = "xg--is-performing",
    IsSelected = "xg--is-selected",
    IsDisabled = "xg--is-disabled",
    IsHidden = "xg--is-hidden",
}
